export default __webpack_public_path__ + "assets/profeature-panel-multiple-old.024258efc098c578e607850809360abf.jpg";